import { render, staticRenderFns } from "./LetsGoSlide.vue?vue&type=template&id=5d5ead52&scoped=true&"
import script from "./LetsGoSlide.vue?vue&type=script&lang=js&"
export * from "./LetsGoSlide.vue?vue&type=script&lang=js&"
import style0 from "./LetsGoSlide.vue?vue&type=style&index=0&id=5d5ead52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ead52",
  null
  
)

export default component.exports